import * as betprofessor from './SignUp.styles.betprofessor';
import * as betroyale from './SignUp.styles.betroyale';
import * as fiestabet from './SignUp.styles.fiestabet';
import * as puntcity from './SignUp.styles.puntcity';
import * as puntgenie from './SignUp.styles.puntgenie';
import * as questbet from './SignUp.styles.questbet';
import * as sterlingparker from './SignUp.styles.sterlingparker';
import * as vikingbet from './SignUp.styles.vikingbet';
import * as volcanobet from './SignUp.styles.volcanobet';
import * as wellbet from './SignUp.styles.wellbet';
import * as juicybet from './SignUp.styles.juicybet';
import * as goldenrush from './SignUp.styles.goldenrush';
import * as forsport from './SignUp.styles.forsport';
import * as junglebet from './SignUp.styles.junglebet';
import * as oldgill from './SignUp.styles.oldgill';
import * as sugarcastle from './SignUp.styles.sugarcastle';
import * as buffalobet from './SignUp.styles.buffalobet';
import * as titanbet from './SignUp.styles.titanbet';
import * as bet777 from './SignUp.styles.bet777';
import * as gigabet from './SignUp.styles.gigabet';
import * as slambet from './SignUp.styles.slambet';
import * as betstride from './SignUp.styles.betstride';
import * as templebet from './SignUp.styles.templebet';
import * as goldenbet888 from './SignUp.styles.goldenbet888';
import * as hyperbet from './SignUp.styles.hyperbet';
import * as chromabet from './SignUp.styles.chromabet';
import * as bet575 from './SignUp.styles.bet575';
import * as epicodds from './SignUp.styles.epicodds';
import * as pyramidbet from './SignUp.styles.pyramidbet';
import * as magnumbet from './SignUp.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
